if (!customElements.get('product-content')) {
  customElements.define('product-content', class ProductContent extends HTMLElement {
    constructor() {
      super();
      this.productInfoWraper = document.querySelector('.product__info-wrapper');

      const parent = this.parentElement;
      const previousElement = parent ? parent.previousSibling : null;
      const followsProductPageSection = previousElement ? previousElement.classList.contains('product-page-section') : false;

      if (this.productInfoWraper && followsProductPageSection) {
        this.productPageSection = previousElement;
        const templateProduct = this.closest('.template-product-wrapper');
        const walletButton = templateProduct ? templateProduct.querySelector('.wallet-button-fade-in') : null;
        if (walletButton) walletButton.innerHTML = '';
        $('.product-section').wrapAll('<div class="product-section-main-wrap" />');
      } else if (this.productInfoWraper && !followsProductPageSection) {
        const productPageSection = document.querySelector('.product-page-section');
        if (productPageSection) {
          productPageSection.classList.add('product-static-buy-tools');
        }
      }
    }
  });
}
